var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"gf-list-grid-controller-static"},[_c('gf-list-grid-controller',{on:{"update":_vm.onGridControllerUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }